import React from "react";
import PropTypes from "prop-types";
import Alert from "@redbubble/design-system/react/Alert";
import Text from "@redbubble/design-system/react/Text";
import Box from "@redbubble/design-system/react/Box";
import { FormattedMessage } from "react-intl";

const ErrorMessage = ({ message }) => {
  return (
    <Box marginTop="m">
      <Alert intent="warning" title="" label={false}>
        <Text display="block">
          <FormattedMessage {...message} />
        </Text>
      </Alert>
    </Box>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.shape({
    defaultMessage: PropTypes.string,
  }).isRequired,
};

export default React.memo(ErrorMessage);
